import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { PROJECTS } from "@/data/content";
import { Reveal, SectionLabel } from "./Reveal";

const Portfolio = () => {
  return (
    <section
      id="work"
      data-testid="portfolio-section"
      className="relative py-24 md:py-36 bg-[#0A1428]"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-14">
          <div className="md:col-span-8">
            <SectionLabel testid="portfolio-label">Selected work</SectionLabel>
            <Reveal>
              <h2 className="font-display font-bold tracking-tight text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
                Real businesses. <span className="text-[#1E6BFF]">Real growth.</span>
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-4 md:text-right">
            <Reveal delay={0.1}>
              <p className="text-gray-400">Every project below is engineered around a single number that matters to the owner.</p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.06} className={p.span}>
              <motion.div
                whileHover="hover"
                data-testid={`project-card-${i}`}
                className="group relative rounded-2xl overflow-hidden border border-white/10 bg-[#111827] cursor-pointer"
              >
                <Link to={`/work/${p.slug}`} className="block">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <motion.img
                    variants={{ hover: { scale: 1.06 } }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A1428] via-[#0A1428]/20 to-transparent" />
                  <div className="absolute top-5 right-5 w-11 h-11 rounded-full bg-[#1E6BFF] flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-300">
                    <ArrowUpRight size={20} className="text-white" />
                  </div>
                </div>
                <div className="p-6 md:p-8 flex items-end justify-between gap-4">
                  <div>
                    <div className="text-xs uppercase tracking-[0.2em] text-[#1E6BFF] font-semibold mb-2">
                      {p.category}
                    </div>
                    <h3 className="font-display font-semibold text-xl md:text-2xl text-white">
                      {p.title}
                    </h3>
                  </div>
                  <div className="text-right shrink-0">
                    <div className="font-display font-bold text-lg md:text-xl text-white">
                      {p.result}
                    </div>
                  </div>
                </div>
                </Link>
              </motion.div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-14 flex justify-center">
            <Link
              to="/portfolio"
              data-testid="see-all-work"
              className="group inline-flex items-center gap-2 rounded-full border border-white/20 hover:border-[#1E6BFF]/60 hover:bg-[#1E6BFF]/10 text-white font-semibold px-8 py-3.5 transition-colors duration-200"
            >
              View the full portfolio
              <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Portfolio;
